<template>
	<div>	

		<div v-if="loading" id="loading">
			<i class="fal fa-circle-notch fa-spin fa-3x fa-fw text-info"></i>
		</div>

		<div v-else>
			<Theme />
			<AboutClient />
		</div>
	</div>
</template>


<script>
'use strict';
import AboutClient from './AboutClient';
import Theme from './Theme';


	export default {
		name: 'App',
		data() {
			return {
				loading: true
			}
		},

		methods: {
		
		},

		computed: {

		},

		components: {
			AboutClient,
			Theme
		},

		beforeMount() {
			this.$store.dispatch('UPDATE_SIGNUP_STATE', this.$root.$el.dataset.onSignUp == 1);
			this.$store.dispatch('UPDATE_HAS_CUSTOM_SKIN_STATE',this.$root.$el.dataset.hasCustomSkin);
		},

		mounted() {},
		created() {
			this.$store.dispatch('GET_CLIENT_SETTINGS')
				.then(() => {
					this.loading = false;
				})
			;
			this.$store.dispatch('GET_THEMES');
		}

	}	
</script>



<style scoped>

#loading {
	margin: 0 auto;
	text-align: center;
}


[v-cloak] {
	display: none;
}

	
</style>